/** Shown to an authenticated user who lacks the super_admin system role. */
import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";

export function AccessDeniedPage(): ReactNode {
  const { identity, logout } = useAuth();

  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <div className="max-w-md rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="mb-2 text-xl font-bold text-red-600">Access denied</h1>
        <p className="mb-4 text-sm text-slate-600">
          The OXBO Admin console requires the <code>super_admin</code> system role.
          {identity?.email && (
            <>
              {" "}
              You are signed in as <strong>{identity.email}</strong>.
            </>
          )}
        </p>
        {identity?.systemRoles?.length ? (
          <p className="mb-4 text-xs text-slate-400">
            Your system roles: {identity.systemRoles.join(", ")}
          </p>
        ) : (
          <p className="mb-4 text-xs text-slate-400">You have no system roles assigned.</p>
        )}
        <button
          type="button"
          onClick={() => void logout()}
          className="rounded border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
